const nodeTypes = {
  ROUTE_NODE: { name: 'ROUTE_NODE', color: 'yellow', label: 'Útpont' },
  START_NODE: { name: 'START_NODE', color: 'green', label: 'Kezdőpont' },
  SHELF_NODE: { name: 'SHELF_NODE', color: 'blue', label: 'Polc' },
  HIGHLIGHTED_SHELF_NODE: { name: 'HIGHLIGHTED_SHELF_NODE', color: 'orange', label: 'Kiemelt polc' },
};

export default nodeTypes;
